module.exports = "PROJECTS"


//////////////////
// WEBPACK FOOTER
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/projects/projects.component.html
// module id = ../../../../../src/app/projects/projects.component.html
// module chunks = main